/**
 * SVG paths and colors for map markers.
 * Shared by GoogleMapView and LeafletMapView for consistent marker styling.
 */

/** Circle (default idea/activity marker). */
export const PATH_IDEA = 'M 0,0 m -3,0 a 3,3 0 1,1 6,0 a 3,3 0 1,1 -6,0';

/** Teardrop pin for research/idea markers on the research map. */
export const PATH_TEARDROP = 'M 0,0 L 2.5,-8 C 4,-9 4,-9 0,-9 C -4,-9 -4,-9 -2.5,-8 Z';

/** Hotel-style bed (headboard + mattress) for lodging markers. */
export const PATH_LODGING = 'M -6,-2 L -3.5,-2 L -3.5,2 L -6,2 Z M -3.5,-1.2 L 6,-1.2 L 6,1.2 L -3.5,1.2 Z';

export const COLOR_IDEA = '#e86c60';
export const COLOR_LODGING = '#0d9488';

export const MARKER_KIND = {
  IDEA: 'idea',
  LODGING: 'lodging',
};
